module.exports = __webpack_public_path__ + "img/alba-maxi-vignette.6f56a685.jpg";